import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

const LABELS = ["Upload", "Metadata", "Risk scan", "Published"];

export function SubmitStepper({ step }: { step: number }) {
  return (
    <div className="flex items-center gap-2">
      {LABELS.map((label, i) => (
        <div key={label} className="flex flex-1 items-center gap-2 last:flex-none">
          <div className="flex items-center gap-2">
            <span
              className={cn(
                "grid size-7 shrink-0 place-items-center rounded-full text-xs font-semibold",
                step === i && "bg-navy text-white",
                step > i && "bg-success text-white",
                step < i && "bg-bg-3 text-fg-3",
              )}
            >
              {step > i ? <Check className="size-4" /> : i + 1}
            </span>
            <span className={cn("text-sm font-medium", step >= i ? "text-fg-1" : "text-fg-3")}>
              {label}
            </span>
          </div>
          {i < LABELS.length - 1 ? <span className="h-px flex-1 bg-border-1" /> : null}
        </div>
      ))}
    </div>
  );
}
